export const USER_NAME = 'name';

export const USERS_TABLE_CELLS = [
  { label: 'Name', key: 'name' },
  { label: 'Title', key: 'title' },
  { label: 'Email', key: 'email' },
  { label: 'Status', key: 'is_active' },
  { label: 'Active Since', key: 'created_at' },
];
